import type { NetworkInterface } from '@rtkwlf/asset-data-service';

import { TableCell, TableRow, Typography } from '@packages/fenrir/components';
import { EMPTY_FIELD_FALLBACK } from 'ae-constants/constants';

const AssetIpTableRow = ({ name, mac, ipAddresses }: NetworkInterface) => (
  <TableRow>
    <TableCell sx={{ borderBottom: 'none', pl: 0, pr: 4, py: 0 }}>
      <Typography variant="body2"> {name ?? EMPTY_FIELD_FALLBACK} </Typography>
    </TableCell>
    <TableCell sx={{ borderBottom: 'none', pl: 0, pr: 4, py: 0 }}>
      <Typography variant="body2">
        {ipAddresses?.length ? ipAddresses.join(', ') : EMPTY_FIELD_FALLBACK}
      </Typography>
    </TableCell>
    <TableCell sx={{ borderBottom: 'none', pl: 0, pr: 4, py: 0 }}>
      <Typography variant="body2">{mac ?? EMPTY_FIELD_FALLBACK}</Typography>
    </TableCell>
  </TableRow>
);

interface AssetIpTableRowsProps {
  networkInterfaces?: NetworkInterface[];
}

export const AssetIpTableRows = ({
  networkInterfaces,
}: AssetIpTableRowsProps) => {
  if (!networkInterfaces?.length) return <AssetIpTableRow />;

  return networkInterfaces?.map(({ name, ipAddresses, mac }) => (
    <AssetIpTableRow
      key={mac || ipAddresses?.join() || name}
      name={name}
      ipAddresses={ipAddresses}
      mac={mac}
    />
  ));
};
